/**
 * String and CSV utilities for keyword review components.
 */

const currencySymbols: Record<string, string> = {
  USD: '$',
  INR: '₹',
  EUR: '€',
  GBP: '£'
};

/** Capitalizes the first letter of each word in a string */
export const capitalizeWords = (text: string): string => {
  if (!text) return 'Uncategorized';
  return text.split(' ').map(word =>
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  ).join(' ');
};

/** Escapes and quotes a value for CSV export, protecting against CSV formula injection */
export const escapeCSV = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return '""';
  let stringValue = String(value);
  // Prevent CSV injection: prepend a single quote to values starting with
  // formula-triggering characters (=, +, -, @, tab, carriage return)
  if (/^[=+\-@\t\r]/.test(stringValue)) {
    stringValue = "'" + stringValue;
  }
  return `"${stringValue.replace(/"/g, '""')}"`;
};

/** Maps a currency code to its symbol, defaulting to $ */
export const getCurrencySymbol = (currencyCode: string): string => {
  return currencySymbols[currencyCode] || '$';
}
